import getBetweenByOneDate from '../../../../../../helpers/filters/get-between-by-one-date'
import { orderRequestType } from '../../../../../../constants/entity-enums/order-request-types'
import { Filters } from '../../../../../../types/strapi/strapi'
import FormValues from '../components/filters-form/types/form-values'


export const buildFilters = (formValues: Partial<FormValues> = {}): Filters => {
    const { requestStatus, createdAt, materialTypeDocId, materialWidth, amount, arrivalDate } =
        formValues
    const filters: Filters = {
        goodsType: { $eq: orderRequestType[0] },
    }

    if (requestStatus) {
        filters.requestStatus = { $eq: requestStatus }
    }

    if (createdAt) {
        filters.createdAt = getBetweenByOneDate(createdAt)
    }

    const materialFilters: Record<string, unknown> = {}

    if (materialTypeDocId) {
        materialFilters.material_type = { documentId: { $eq: materialTypeDocId } }
    }

    if (materialWidth != null && materialWidth !== '') {
        const width = Number(materialWidth)
        if (!Number.isNaN(width)) {
            materialFilters.width = { $eq: width }
        }
    }

    if (Object.keys(materialFilters).length > 0) {
        filters.material = materialFilters
    }

    if (amount != null && amount !== '') {
        const amountNum = Number(amount)
        if (!Number.isNaN(amountNum)) {
            filters.amount = { $eq: amountNum }
        }
    }

    if (arrivalDate) {
        filters.receipt_position = {
            receipt: {
                estimatedDate: getBetweenByOneDate(arrivalDate),
            },
        }
    }

    return filters
}
